export default __webpack_public_path__ + "static/media/main-characters-end-lg-1x.ac79ee32.jpg";